import { render, staticRenderFns } from "./NotificationsTest.vue?vue&type=template&id=7af1e3da"
import script from "./NotificationsTest.vue?vue&type=script&lang=js"
export * from "./NotificationsTest.vue?vue&type=script&lang=js"
import style0 from "./NotificationsTest.vue?vue&type=style&index=0&id=7af1e3da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports